import { useState } from 'react'
import { Layout } from '../../widgets'
import * as routes from '../../routes'
import { AdminHashtagCell } from '../components'
import { NavigationTab, PaginatedList } from '../../components'
import { useAdminTitle } from '../../shared'

const AdminHashtags = (props) => {
  const [tab, setTab] = useState('Trending')

  useAdminTitle('Hashtags')

  const tabs = {
    'Trending': <PaginatedList
      key={'trending'}
      loadUrl={routes.adminHashtagTrendingUrl}
      loadParams={{}}
      cell={AdminHashtagCell}
      cellItemPropName={'hashtag'}
      datePicker={false}
      featureActionUpdateBehavior={'filter'}
    />,
  }

  return (
    <div className='body-container'>
      <Layout>
        <Layout.Header>Hashtags</Layout.Header>
        <div className='moderator-content'>

          <div className='navigation-tabs'>
            {Object.keys(tabs).map((t, i) =>
              <NavigationTab
                key={i}
                text={t}
                isActive={tab === t}
                onClick={() => {
                  if (tab !== t) {
                    setTab(t)
                  }
                }}
              />
            )}
          </div>

          {tabs[tab]}

        </div>
      </Layout>
    </div>
  )
}

export default AdminHashtags
